'use client';

import { useEffect } from 'react';

import { analytics } from '@kit/analytics';

import { DancerEvent } from '~/lib/analytics/dancer-events';

interface TrackAuditionPageviewProps {
  auditionId: string;
}

/**
 * Client tracker for the audition detail view. The detail page and
 * `PublicAuditionView` are server components (PPR), so a `useEffect` capture
 * mounted here is the client entry point. Mirrors `track-org-pageview.tsx`.
 * A "being found" adjacency signal on the dancer's own browsing — an H1/H3
 * candidate (does viewing auditions predict retention / faster time-to-aha).
 */
export function TrackAuditionPageview({
  auditionId,
}: TrackAuditionPageviewProps) {
  useEffect(() => {
    void analytics.trackEvent(DancerEvent.AuditionViewed, {
      audition_id: auditionId,
    });
  }, [auditionId]);

  return null;
}
